@if (emptyList()) {
  <ng-container *ngTemplateOutlet="empty" />
} @else {
  <app-table
    [columns]="tableColumnsService.visibleColumns()"
    [datas]="tableData()"
    [actions]="actions()"
    (columnsChange)="tableColumnsService.reorderColumns($event)"
    [skeletonCount]="skeletonCount()"
  />

  <app-paginator
    [isLoading]="!tableData()"
    [page]="workoutTableContentService.currentPage()"
    [totalItems]="workoutTableContentService.totalItems()"
    [itemsPerPage]="workoutTableContentService.contentLimitPerPage()"
    (nextPage)="workoutTableContentService.nextPage()"
    (previousPage)="workoutTableContentService.previousPage()"
    [firstItemInCurrentPage]="workoutTableContentService.firstItemInPage()"
    [lastItemInCurrentPage]="workoutTableContentService.lastItemInPage()"
    [lastPage]="workoutTableContentService.lastPage()"
    (goToPage)="workoutTableContentService.goToPage($event)"
    (setItemPerPage)="workoutTableContentService.setItemPerPage($event)"
  />
}

<ng-template #empty>
  <app-empty-content-list-element contentType="workout" />
</ng-template>
